import { Box, Divider } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import { RuleFooter } from '@wix/rules-panel-ui';
import { useSetAtom } from 'jotai/index';
import React from 'react';
import { colorsInSessionAtom } from '../../../../../atoms/session-atoms';
import { useResetUnsavedChangesHandlers } from '../../../../../hooks/use-reset-unsaved-changes-handlers';
import { useCurrentElement } from '../../hooks/use-current-element';
import { ContrastRatioLevel } from '../../types';
import { ColorSlider } from './color-slider';
import { RatioDisplay } from './ratio-display';
const BRIGHTNESS_MAX_SCALE = 100;
export const ColorContrastControls = _ref => {
  let {
    failedElement,
    onClickCancel,
    onClickApply,
    onChangeElementsColor,
    showLoader,
    elementIndex,
    status,
    isGeneric,
    pageId
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    minimalRatio
  } = failedElement;
  const {
    bgColorState,
    textColorState,
    currentContrastRatio,
    hasColorsChanged,
    isApplyClickedRef,
    updateUserColorPalette,
    updatedElement
  } = useCurrentElement({
    element: failedElement,
    elementIndex,
    isGeneric,
    minimalRatio,
    onChangeElementsColor,
    onClickApply,
    pageId
  });
  const setColorsInSession = useSetAtom(colorsInSessionAtom);
  const {
    resetUnsavedChangesHandlers
  } = useResetUnsavedChangesHandlers();

  // TODO: once we implement the AAA level, we should update this condition
  const currentContrastRatioLevel = currentContrastRatio >= minimalRatio ? ContrastRatioLevel.AA : ContrastRatioLevel.Fail;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ColorSlider, {
    colorPickerAriaLabel: t('accessibility-wizard.rules-list.color-contrast.color-picker.foreground.aria-label', {
      color: textColorState.hex
    }),
    colorState: textColorState,
    currentContrastRatioLevel: currentContrastRatioLevel,
    index: elementIndex,
    isGeneric: isGeneric,
    label: t('accessibility-wizard.rules-list.color-contrast.element.foreground'),
    maxScale: BRIGHTNESS_MAX_SCALE,
    sliderType: "foreground",
    status: status
  }), /*#__PURE__*/React.createElement(ColorSlider, {
    colorPickerAriaLabel: t('accessibility-wizard.rules-list.color-contrast.color-picker.background.aria-label', {
      color: bgColorState.hex
    }),
    colorState: bgColorState,
    currentContrastRatioLevel: currentContrastRatioLevel,
    index: elementIndex,
    isGeneric: isGeneric,
    label: t('accessibility-wizard.rules-list.color-contrast.element.background'),
    maxScale: BRIGHTNESS_MAX_SCALE,
    sliderType: "background",
    status: status
  }), !isGeneric && /*#__PURE__*/React.createElement(Box, {
    paddingTop: "SP1"
  }, /*#__PURE__*/React.createElement(Divider, null)), /*#__PURE__*/React.createElement(RatioDisplay, {
    contrastRatioLevel: currentContrastRatioLevel,
    index: elementIndex,
    isGeneric: isGeneric,
    ratio: currentContrastRatio,
    status: status
  }), !isGeneric && /*#__PURE__*/React.createElement(RuleFooter, {
    dismissButtonProps: {
      label: t('accessibility-wizard.rules-list.color-contrast.cta.secondary'),
      onClick: () => {
        onClickCancel();
        resetUnsavedChangesHandlers();
      }
    },
    submitButtonProps: {
      disabled: currentContrastRatioLevel === ContrastRatioLevel.Fail || !hasColorsChanged,
      label: t('accessibility-wizard.rules-list.color-contrast.cta.primary'),
      onClick: () => {
        setColorsInSession(updateUserColorPalette);
        onClickApply({
          bgColorState,
          currentContrastRatio,
          currentContrastRatioLevel,
          element: updatedElement,
          elementIndex,
          textColorState
        });
        isApplyClickedRef.current = true;
        resetUnsavedChangesHandlers();
      },
      showLoader
    }
  }));
};
//# sourceMappingURL=color-contrast-controls.js.map